import { postRequest } from 'utils/api'
import {
  AI_ROLE_PLAY_V2_URL,
  PUBLIC_ROLE_PLAYS_URL,
  ROLE_PLAY_TYPES
} from './constants'
import { getPublicUser } from 'utils/localStorage'

export const getRolePlayResponse = async (
  rolePlayId,
  isPublicRolePlay,
  complete,
  rolePlayMessages,
  conversationSeconds,
  notes,
  type = ROLE_PLAY_TYPES.TEXT_CHAT
) => {
  let requestBody = {
    rolePlayId,
    rolePlayMessages,
    isWithAudio: false,
    notes: notes?.length ? notes : null,
    complete,
    conversationSeconds,
    type
  }
  if (isPublicRolePlay && complete) {
    const publicUser = getPublicUser()
    if (publicUser?.email) {
        const {token, ...otherValues} = publicUser
        requestBody = {...requestBody, ...otherValues}
    }
  }
  const res = await postRequest(
    isPublicRolePlay ? PUBLIC_ROLE_PLAYS_URL : AI_ROLE_PLAY_V2_URL,
    requestBody
  )
  return res
}
